import { APP_HERO_PRODUCTS, HeroProduct } from '@white-label-configuration/constants';
import { getAppHeroProduct } from './get-app-hero-product';

export function heroProductIs(heroProduct: HeroProduct): boolean {
    return getAppHeroProduct(APP_HERO_PRODUCTS.PARKING) === heroProduct;
}
